import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFines } from "../hooks/useFines";
import { API_URL } from "../../../Constants";

export const PaymentSimulation = () => {
    const navigate = useNavigate();
    const { trafficTickets } = useFines();
    const [loading, setLoading] = useState<boolean>(false);
  

    const handlePaymentResponse = async (status: "success" | "error") => {
        if (!trafficTickets) return;

        setLoading(true);

        // Simular los datos que enviaría BBVA/FLAP según la documentación
        const paymentResponse = {
            s_transm: trafficTickets.order,
            c_referencia: trafficTickets.reference,
            n_autoriz: status === "success" ? "123456" : null,
            t_pago: status === "success" ? "APPROVED" : "DECLINED",
            t_importe: trafficTickets.amount.toFixed(2),
            s_pago: status === "success" ? "SUCCESS" : "FAILED",
            val_1: "Placa",
            val_2: "0",
            val_3: null,
            s_mail: "usuario@example.com",
            mp_signature: "simulated_signature", // En producción, calcular según documentación
            FechaP: new Date().toISOString(),
            mp_authorization: status === "success" ? "AUTH123" : "000000", // '000000' para error
            mp_responsemsg: status === "error" ? "Transacción rechazada" : null,
        };

        try {
            const response = await fetch(`${API_URL}fines/payment-response`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(paymentResponse),
            });

            const result = await response.json();

            /*Para obtener el resultado de succes o failure*/
            const queryParams = new URLSearchParams({
                status: status,
                order: trafficTickets.order
            }).toString();

            if (result.status === "success") {

                navigate(`/payment-result?${queryParams}&order=${trafficTickets.order}`);
                //navigate(`/payment-result?status=success&order=${trafficTickets.order}`);
            } 
            else {
                navigate(
                    // `/payment-result?status=failure&order=${trafficTickets.order}&message=${encodeURIComponent(
                    //     result.message || "Error desconocido"
                    `/payment-result?${queryParams}&order=${trafficTickets.order}
                    )}`
                );
                
            }
        } catch (error) {
            console.error("Error al procesar la simulación:", error);
            alert("Error al conectar con el servidor");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex justify-center items-center min-h-screen bg-[#f4f5f5]">
            <div className="w-full max-w-md bg-white p-6 rounded-lg shadow-lg">
                <h1 className="text-2xl font-bold text-center text-black mb-6">SIMULACIÓN DE PAGO</h1>
                <div className="flex flex-col gap-4">
                    <button
                        onClick={() => handlePaymentResponse("success")}
                        className={`px-6 py-2 text-white rounded-md transition-colors ${loading ? "bg-gray-400 cursor-not-allowed" : "bg-green-500 hover:bg-green-600"
                            }`}
                        disabled={loading}
                    >
                        Pago Aceptado
                    </button>
                    
                    <button
                        onClick={() => handlePaymentResponse("error")}
                        className={`px-6 py-2 text-white rounded-md transition-colors ${loading ? "bg-gray-400 cursor-not-allowed" : "bg-red-500 hover:bg-red-600"
                            }`}
                        disabled={loading}
                    >
                        Error en Pago
                    </button>
               
                </div>
            </div>
        </div>
    );
};